import { TwainGameId } from 'betgames-contract-js';
import { IParticipantResultStats } from 'twain-sport-fe-mono/interfaces';
import { SMALL_SHOTS_AMOUNT } from '../constants';

export const getRandomBadShotsAmount = (
    gameId: TwainGameId,
    left: IParticipantResultStats,
    rigth: IParticipantResultStats,
): string => {
    const list = [];
    if (left.totalHits < SMALL_SHOTS_AMOUNT[gameId]) {
        list.push('inPlayBad.4');
    }

    if (rigth.totalHits < SMALL_SHOTS_AMOUNT[gameId]) {
        list.push('inPlayBad.8');
    }

    return list.length ? list[Math.floor(Math.random() * list.length)] : null;
};
